import axios from 'axios';
import { API_URL } from '../../global/components/Constants';

export const saveApplicant = async (job, cv) => {
  try {
      const response = await axios.post(`${API_URL}job/save_applicant`, {job:job, cv:cv}, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
      });
      return response.data;
  } catch (error) {
      throw error;
  }
}

export const getJobPosts = async (page, query) => {

  try {
    const response = await axios.get(
      `${API_URL}job/job_posts?page=${page}&query=${query}`, 
      {withCredentials: true}
    );
    const obj = response.data;
    if(obj.Success){
        if(obj.Data.length > 0){
          return obj.Data;
        }
    }

    return [];

  } catch (error) {
    return [];
  }
}

export const getTopJobPosts = async () => {
  try {
    const response = await axios.get(`${API_URL}job/top_job_posts`,  {withCredentials: true});
    const obj = response.data;
    if(obj.Success){
        if(obj.Data.length > 0){
          return obj.Data;
        }
    }
    return [];
  } catch (error) {
    return [];
  }
}

export const getCategoryJobPosts = async (category, page, query) => {

  try {
    const response = await axios.get(
      `${API_URL}job/job_posts_by_category?category=${category}&page=${page}&query=${query}`, 
      {withCredentials: true}
    );
    const obj = response.data;
    if(obj.Success){
        if(obj.Data.length > 0){
          return obj.Data;
        }
    }

    return [];

  } catch (error) {
    return [];
  }
}

export const getUserJobPosts = async (page, query) => {

  try {
    const response = await axios.get(
      `${API_URL}job/user_job_posts?page=${page}&query=${query}`, 
      {withCredentials: true}
    );
    const obj = response.data;
    if(obj.Success){
        if(obj.Data.length > 0){
          return obj.Data;
        }
    }

    return [];

  } catch (error) {
    return [];
  }
}

export const deleteJobPost = async (payload) => {
  try {
      const response = await axios.post(`${API_URL}job/delete_job`, payload, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
      });
      return response.data;
  } catch (error) {
      throw error;
  }
}

export const getJobCount = async (category) => {
  try {
    const response = await axios.get(`${API_URL}job/job_count?category=${category}`);
    const obj = response.data;
    if(obj.Success){
        if(obj.Data != null){
          return obj.Data;
        }
    }

    return null;

  } catch (error) {
    return null;
  }
}